/*******************************************************************************
  설  명 : 메인화면
  작성자 : 송영석
  작성일 : 2020-05-18
*******************************************************************************/
import { Component, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService, LangChangeEvent, TranslationChangeEvent } from '@ngx-translate/core';
import { fromEvent, Observable, Subscription } from "rxjs";
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';

import { CommonService } from '@app/service/common.service';
import { MainService } from '@app/home/service/main.service';
import { LanguageService } from '@app/service/language.service';

import { O2OZCMS } from '@app/components/o2oz-cms/o2oz-cms.component';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent extends O2OZCMS implements OnInit {

  /*******************************************************************************
    설명 : 전역 변수 선언부
  *******************************************************************************/
  resizeObservable$: Observable<Event>;
  resizeSubscription$: Subscription;

  public params: any = {
    language: 'ko'
  };

  public isMobile: any = false;

  public maintenanceList: any = [];
  public popupList: any = [];
  public is_popup_preview: any = [];

  public screenWidth: any;
  swiperCertification : SwiperConfigInterface; // 인증서 swiper
  swiperAs : SwiperConfigInterface; // AS사업 swiper

  public SwiperConfigInterface_main: SwiperConfigInterface = {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },  
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },          
    navigation: {
      nextEl: '.swiper-button-next1',
      prevEl: '.swiper-button-prev1',
    },
  };

  public SwiperConfigInterface_certification: SwiperConfigInterface = {
    slidesPerView: 1,
    spaceBetween: 0,
    direction: 'vertical',
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },  
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    }   
  };  
  
  public SwiperConfigInterface_certification_m: SwiperConfigInterface = {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },  
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    }   
  };  

  public SwiperConfigInterface_as: SwiperConfigInterface = {
    effect: 'fade', 
    fadeEffect: { crossFade: true },
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    }, 
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  };

  public SwiperConfigInterface_as_m: SwiperConfigInterface = {
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
    },
  };

  asIndex = 0; // as사업 선택 

  /*******************************************************************************
    설  명 : 생성자
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  constructor(
    router: Router,
    commonService: CommonService,
    activatedRoute: ActivatedRoute,
    toastrService: ToastrService,
    private mainService: MainService,
    private cookieService: CookieService,
    private languageService: LanguageService,
    private translate: TranslateService
  ) {
    // 상위 클래스에 router 전달
    super(router, commonService, activatedRoute, toastrService);

    this.onResize();

    // 다국어 설정이 파라미터로 넘어온 경우 처리
    activatedRoute.queryParams.subscribe(params => {
      if( typeof params.language !== 'undefined' && params.language !== '' ) {
        this.params.language = params.language;

        this.getBoardMaintenanceList();
      }
    });
  }

  /*******************************************************************************
    설  명 : 데이터 초기화
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  ngOnInit(): void {
    if ( window.innerWidth <= 720 ) {
      this.isMobile = true;
    }

    this.resizeObservable$ = fromEvent(window, 'resize')
    this.resizeSubscription$ = this.resizeObservable$.subscribe( evt => {
      if ( window.innerWidth <= 720 ) {
        this.isMobile = true;
      }
    })

    // 배너 및 팝업
    this.getBoardPopupList();

    // 유지보수 리스트 가져오기
    this.getBoardMaintenanceList();
  }

  /*******************************************************************************
    설  명 : 날짜 비교
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  dateDiff(sdate, edate) {
    sdate = sdate.split('-').join('');
    edate = edate.split('-').join('');
    const today = moment().format('YYYY') + moment().format('MM') + moment().format('DD');

    if (sdate > today || edate < today) {
      return true;
    }
  }

  /*******************************************************************************
    설  명 : 팝업 리스트 정보 가져오기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  getBoardPopupList() {
    this.mainService.getPopupList( {board_id: 'popup', limit: '0'} ).then( response => {
      if ( response.ResultCode) {
        if ( response.data.length > 0 ) {
          response.data.forEach( row => {

            if (this.dateDiff(row.notice_sdate, row.notice_edate)) {
              return true;
            }

            if ( this.getPopupToday(row.board_seq) ) {
              if ( row.layer_popup == true ) {
                row.is_popup_preview = true;
                this.popupList.push(row);
              } else {
                const url = 'http://ref.o2oz.net/api/popup/popup.php?board_id=' + row.board_id + '&board_seq=' + row.board_seq;
                window.open(url, '', 'resizable=no, toolbar=no, scrollbars=auto, menubar=no, directories=no, location=no, width='+row.popup_width+', height='+(parseInt(row.popup_height, 10) + 108)+', left='+row.screen_x+', top=' + row.screen_y );
              }
            }
          });
        }
      }
    });
  }

  /*******************************************************************************
    설  명 : 유지보수 리스트 정보 가져오기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  getBoardMaintenanceList() {
    this.mainService.getBoardListLimit( {board_id: 'maintenance', limit: '7', language: this.params.language } ).then( response => {
      if ( response.ResultCode ) {
        this.maintenanceList = response.data;
      } else {
        this.toastrService.error( response.ResultMessage );
      }
    });
  }
  
  /*******************************************************************************
    설  명 : 팝업 오늘 더 이상 보지 않기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
    getPopupToday( boardSeq ) {
      if ( this.cookieService.get( 'popup' + boardSeq ) == 'hidden' ) {
        return false;
      } else {
        return true;
      }
    }
  
    /*******************************************************************************
      설  명 : 팝업 오늘 더 이상 보지 않기
      입력값 : 없음
      리턴값 : 없음
    *******************************************************************************/
    setPopupToday( row ) {
      this.cookieService.set( 'popup' + row.board_seq, 'hidden', 1 );
  
      row.is_popup_preview = false;
    }

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    this.screenWidth = window.innerWidth;
    if ( this.screenWidth > 720 ) {
      this.swiperCertification = this.SwiperConfigInterface_certification;   
      this.swiperAs = this.SwiperConfigInterface_as;
    } else {
      this.swiperCertification = this.SwiperConfigInterface_certification_m;    
      this.swiperAs = this.SwiperConfigInterface_as_m;
    }      
  }

}
